import { h, Component } from 'preact';
import InstacredTnC from '../../../../components/common/instacredTnC';
import MuiInput from '../../../../components/material-ui/muiInput';
import RequestButton from '../../../../components/requestButton';
import style from './style.css';
import { getNumericValue } from '../../../../utils/stringOperations';
import actionType from '../../../../actions/ntbAction/actionType';
import { tracker, UserActionType } from '../../../../tracking';
import { connect } from 'react-redux';
import ntbAction from '../../../../actions/ntbAction';

class OtpInput extends Component {
  state = {
    otp: '',
    resendCounter: 30,
    isTermsAccepted: false,
  };
  componentDidMount() {
    this.initTimer();
  }
  initTimer = () => {
    this.intervalId = setInterval(this.timer, 1000);
  };

  timer = () => {
    this.setState(
      ({ resendCounter }) => ({
        resendCounter: resendCounter - 1,
      }),
      () => {
        if (this.state.resendCounter === 0) {
          clearInterval(this.intervalId);
        }
      },
    );
  };
  resendOtp = () => {
    this.setState(
      {
        otp: '',
        resendCounter: 30,
      },
      this.initTimer,
    );
    tracker.trackUserInteraction(
      UserActionType.CLICK,
      'ap_resend_otp',
      this.pageKey,
      '',
    );
    const { channel, merchantId, mobileNo } = this.props || {};
    this.props.ntbAction(actionType.sendOTP, {
      mobile: mobileNo,
      merchantId,
      channel,
    });
  };

  resetTimer = () => {
    this.setState({
      resendOtpVisible: true,
    });
  };

  trackUserAction = (elementName, pageKey, other) => {
    tracker.trackUserInteraction(UserActionType.CLICK, elementName, pageKey, {
      ...other,
    });
  };

  onTryAnotherNumber = () => {
    tracker.trackUserInteraction(
      UserActionType.CLICK,
      'try_another_number_icici',
      this.pageKey,
      '',
    );
    this.props.mobileOnChange('');
    this.props.ntbAction(actionType.closeOtpOverLayScreen);
    this.props.ntbAction(actionType.resetUserStatus);
  };
  render() {
    const {
      pageKey,
      mobileNo,
      ntbAction,
      channel,
      utmSource,
      utmMedium,
      campaignId,
      utmContent,
      utmTerm,
      variation,
      userStatus,
      merchantId,
    } = this.props || {};
    const { isTermsAccepted } = this.state;
    return (
      <div className={style.campaignOtpInputContainer}>
        <MuiInput
          inputID='otp'
          inputPlaceholder='Enter 5 Digit OTP'
          pageKey={pageKey}
          maxLength={5}
          minLength={5}
          inputValue={this.state.otp}
          inputType='tel'
          className={style.otpInputBox}
          onChange={(e) => {
            const otp = getNumericValue(e.target.value);
            this.setState({ otp });
          }}
          elementName='ap_enter_otp'
        />
        {userStatus === 'notEligibleIcici' && (
          <div class='inputError' style={{ marginBottom: '15px' }}>
            Sorry ! This number is not approved with this lender . Try with{' '}
            <span
              class='bold-text linkColor'
              style='cursor:pointer;'
              onClick={this.onTryAnotherNumber}>
              another number
            </span>
          </div>
        )}
        {userStatus !== 'notEligibleIcici' && (
          <InstacredTnC
            isTermsAccepted={isTermsAccepted}
            onClickTermsAccepted={(isTermsAccepted) => {
              this.setState({ isTermsAccepted });
              isTermsAccepted &&
                tracker.trackUserInteraction(
                  UserActionType.SELECT,
                  'ap_accept_t&c',
                  pageKey,
                  '',
                );
            }}
            pageKey={pageKey}
            trackUserAction={this.trackUserAction}
          />
        )}
        <RequestButton
          buttonDisabled={
            this.state.otp.length !== 5 ||
            !isTermsAccepted ||
            userStatus === 'notEligibleIcici'
          }
          buttonId='verifyOtpButton'
          loadingMsg='Verifying...'
          pageKey={pageKey}
          buttonWrapperClass={style.otpSubmitButton}
          elementName='ap_verify_otp'
          utmSource={utmSource}
          utmMedium={utmMedium}
          campaignId={campaignId}
          utmContent={utmContent}
          utmTerm={utmTerm}
          buttonText='Verify'
          buttonOnClick={() => {
            return ntbAction(actionType.verifyOTP, {
              mobile: mobileNo,
              otp: this.state.otp,
              channel,
              utmSource: utmSource,
              utmMedium: utmMedium,
              campaignId: campaignId,
              utmContent: utmContent,
              utmTerm: utmTerm,
              variation: variation,
              merchantId: merchantId,
            });
          }}
          requestStatus={false}
        />
        <div>
          <div style={{ textAlign: 'right', margin: 8 }}>
            {this.state.resendCounter > 0 ? (
              <div className={`font12 bold-text text-color`}>
                {this.state.resendCounter} seconds left
              </div>
            ) : (
              <div>
                <span
                  className='font12 bold-text cursorPointer linkText'
                  onClick={this.resendOtp}>
                  Resend OTP
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ ntbConfig }) => {
  const { userStatus } = ntbConfig;
  return {
    userStatus,
  };
};

export default connect(
  mapStateToProps,
  { ntbAction },
)(OtpInput);



// WEBPACK FOOTER //
// ./routes/campaign-fast-feature/components/otp-input/index.js